var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddArtist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5714 10.8571C24.5714 7.07005 21.5014 4 17.7143 4C13.9272 4 10.8571 7.07005 10.8571 10.8571C10.8571 14.6442 13.9272 17.7143 17.7143 17.7143C21.5014 17.7143 24.5714 14.6442 24.5714 10.8571ZM17.7143 6.28572C15.1896 6.28572 13.1429 8.33242 13.1429 10.8572C13.1429 13.3819 15.1896 15.4286 17.7143 15.4286C20.239 15.4286 22.2857 13.3819 22.2857 10.8572C22.2857 8.33242 20.239 6.28572 17.7143 6.28572Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20C26.3118 20 31.4286 25.1167 31.4286 31.4286V36H4V31.4286C4 25.1167 9.11675 20 15.4286 20H20ZM20.4563 22.2969L20 22.2857H15.4286L14.9576 22.2976C10.4341 22.5272 6.77811 26.0444 6.33155 30.5073L6.2969 30.9723L6.28571 31.4286V33.7143H29.1429V31.4286L29.1309 30.9576C28.9014 26.4341 25.3842 22.7781 20.9213 22.3316L20.4563 22.2969Z",
    fill: "#1B0076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0353 11.9569H36V10.0431H33.0353V7H30.9647V10.0431H28V11.9569H30.9647V15H33.0353V11.9569Z",
    fill: "#1B0076",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArtist);
export default __webpack_public_path__ + "static/media/add-artist.76140cbef65414f639331a5d40d26dce.svg";
export { ForwardRef as ReactComponent };